import React from 'react'

const Others = ({image, title, content, style}) => {
  return (
    <div className='flex flex-row items-center gap-3'>
        <img src={image} alt="" />
        <div className='flex flex-col gap-1'>
            <p className={style}>{title}</p>
            <p className='text-white text-opacity-75 text-[15px]'>{content}</p>
        </div>
    </div>
  )
}

export default Others